module.exports = __webpack_public_path__ + "static/media/Repair-red.b78dace0.svg";